import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { store } from './store';
import { setTheme } from './store/slices/themeSlice';
import Layout from './components/layout/Layout';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import LearnPage from './pages/LearnPage';
import LessonDetailPage from './pages/LessonDetailPage';
import TipsPage from './pages/TipsPage';
import StoriesPage from './pages/StoriesPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminLoginPage from './pages/AdminLoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminDashboard from './pages/AdminDashboard';
import './i18n';

function AppRoutes() {
  const dispatch = useDispatch();
  const { mode } = useSelector((s) => s.theme);

  useEffect(() => {
    dispatch(setTheme(mode));
  }, [dispatch, mode]);

  return (
    <Routes>
      {/* Admin login — standalone layout (no public navbar) */}
      <Route path="/admin/login" element={<AdminLoginPage />} />

      {/* Public + user routes with main layout */}
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/learn" element={<LearnPage />} />
            <Route path="/learn/:id" element={<LessonDetailPage />} />
            <Route path="/tips" element={<TipsPage />} />
            <Route path="/stories" element={<StoriesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </Layout>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" toastOptions={{ duration: 4000, style: { borderRadius: '12px' } }} />
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  );
}
